<div class="page-header">
    <div class="page-title-row">
        <button type="button" class="page-back" (click)="goBack()" [attr.aria-label]="'back' | translate">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13.5" fill="#F7F9FC" stroke="#2563EB"/>
                <path d="M15.8662 7.875L9.625 14.1162L15.8662 20.3575L17.413 18.8107L12.7186 14.1162L17.413 9.42177L15.8662 7.875Z" fill="#2563EB"/>
            </svg>
        </button>
        <h1 class="page-title">{{ title | translate }}</h1>
    </div>
    @if (breadcrumbs.length) {
        <lokos-breadcrumb [items]="breadcrumbs"></lokos-breadcrumb>
    }
</div>
